<template>
  <div
    id="progress"
    :style="{ visibility: visible ? 'visible' : 'hidden' }"
    class="progress">
    <span
      :style="{ width: `${progress}%` }"
      :class="customClass" />
  </div>
</template>

<script>
export default {
  name: 'QxProgress',
  props: {
    progress: {
      type: Number,
      required: true,
    },
    visible: {
      type: Boolean,
      default: true,
    },
    customClass: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
#progress {
  width: 100%;
  height: 5px;
  margin-top: 5px;
  background-color: $hover-grey;
  border-radius: 2px;
  span {
    width: 0px;
    height: 5px;
    display: block;
    background-color: $base-orange;
    transition:
      width 0.3s,
      background-color 0.3s,
      transform 0.3s;
  }
}
</style>
